import { buildPortalUrl } from "../../utils/url";

export interface NavLink {
    label: string;
    href: string;
}

export const MARKETING_NAV_LINKS: NavLink[] = [
    { label: "About", href: "/#about" },
    { label: "Testimonials", href: "/#testimonials" },
    { label: "Features", href: "/#features" },
    { label: "Pricing", href: "/#pricing" },
    { label: "Eisha", href: "/#eisha" }
];

export const MARKETING_ACTIONS = {
    contact: { label: "Contact", href: "#contact" },
    login: { label: "Log In", href: buildPortalUrl({ mode: "login", content: "nav_login" }) },
    cta: { label: "Get Started", href: buildPortalUrl({ mode: "register", content: "nav_login" }) }
};
